import Button from '@sber-site/sbercraft-nova-kit/components/Button';
import { useEffect } from 'react';
import Link from '@sber-site/sbercraft-nova-kit/components/Link';
import bem from 'bem-cn';

import { pushRetentionShowButton, sendToAnalytics } from '../../analytics/web-analytics';

const cn = bem('retention');

export default function RetentionButton({
    textButton,
    textFromServiceVar,
    linkButton,
    hasSurveryVariables,
    handleServeryShow,
}) {
    useEffect(() => {
        pushRetentionShowButton(textButton, linkButton);
    }, []);

    const textRetentionButton = hasSurveryVariables ? (
        textButton
    ) : (
        <Link className={cn('linkButton')()} href={textFromServiceVar?.linkButton || ''} type='secondary' size='sm' target='_blank'>
            {textButton}
        </Link>
    );
    return (
        <Button
            onClick={() => {
                sendToAnalytics('retention_click_button', `${textButton}`);
                if (hasSurveryVariables) {
                    handleServeryShow(true);
                }
            }}
            size='sm'
            className={cn('button')()}
            type='tertiary'
        >
            {textRetentionButton}
        </Button>
    );
}
